import { addIndex, map, reduce, curry } from 'ramda';

import i18n from 'services/i18n';

export const mapIndex = addIndex(map);
export const reduceIndex = addIndex(reduce);

export const ifElseWithI18n = curry((fn, trueValue, falseValue, value) =>
  fn(value) ? i18n.t(trueValue) : i18n.t(falseValue),
);
